export const getShorthandColor = (color: string) => {
    let clr = color;

    clr = clr.replace(/^#/, '');

    return `#${clr[0]}${clr[2]}${clr[4]}`;
};
